import { fn } from "storybook/test";

type UpdatePublicationEmailAccessRequest = {
  emails: string[];
  enabled: boolean;
  pin_via_email?: boolean;
};

export const mockUpdatePublicationEmailAccess = fn(
  (data: UpdatePublicationEmailAccessRequest) => {
    // Simulate API call
    return Promise.resolve({
      data: {
        message: "Publication email access updated successfully",
        emails_configured: data.emails.length,
        enabled: data.enabled,
      },
    });
  }
);

export const useUpdatePublicationEmailAccess = () => {
  return {
    mutate: mockUpdatePublicationEmailAccess,
    mutateAsync: mockUpdatePublicationEmailAccess,
    isLoading: false,
    isError: false,
    error: null,
    data: null,
    reset: () => {},
  };
};
